import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  ConfirmationDialog,
  NotificationService,
} from '../../../core/services/notification/notification.service';

/**
 * T11 — Confirmation dialog modal. Subscribes to
 * `confirmationDialog$` and renders a centered modal with confirm/cancel.
 */
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
    imports: [CommonModule],
  selector: 'app-notification-confirmation-dialog',
  templateUrl: './notification-confirmation-dialog.component.html',
  styleUrls: ['./notification-confirmation-dialog.component.scss'],
})
export class NotificationConfirmationDialogComponent implements OnInit, OnDestroy {
  dialog: ConfirmationDialog | null = null;

  private sub?: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.sub = this.notificationService.confirmationDialog$.subscribe((d) => {
      this.dialog = d;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onConfirm(): void {
    this.dialog?.confirmCallback();
  }

  onCancel(): void {
    this.dialog?.cancelCallback?.();
  }

  /** Backdrop click = cancel (matches native confirm() ergonomics). */
  onBackdropClick(): void {
    this.onCancel();
  }
}
